/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQueryWorkloadOwner extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("WorkloadQueryWorkloadOwner");
    }

    getFixupPrototypeFunction() { return WorkloadQueryWorkloadOwner.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQueryWorkloadOwner>): WorkloadQueryWorkloadOwner {
        let obj = Object.assign(new WorkloadQueryWorkloadOwner(), model);
        WorkloadQueryWorkloadOwner.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQueryWorkloadOwner>): WorkloadQueryWorkloadOwner {
        if (!model) return null;
        return WorkloadQueryWorkloadOwner.newInstance(<WorkloadQueryWorkloadOwner> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQueryWorkloadOwner) {
        if (!obj) return;

        models.WorkloadQueryWorkloadOwner.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQueryWorkloadOwner): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadQueryWorkloadOwner.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owners of Workload
     */
    workload_owners: Array<string>;

}
